<!-- Template -->

<template>  
    <Layout :path="path" :hospital="hospital" :hospitals="hospitals" :section="'systems'" :loading="loading">
        <div v-if="system" class="selected-system">
            <SystemHeader :system="system" :hospital="hospital"/>
            <SystemInfo :system="system"/>
            <SystemNavigation :tabs="tabs" :active="tab.name" :hospital="hospital" :system="system" />            
            <div class="tab-content horizontal">
                <div class="tab-pane fade show active">
                    <keep-alive>
                        <component  v-if="tab" :is="tab.component" :system="system" :hospital="hospital"/>	
                    </keep-alive>	
                </div> 
            </div>
        
        </div>  

    </Layout>  
</template>

<!-- Script -->

<script>
    import '@/prototypes/array';
    import { HospitalService } from '@/services/hospital-service';
    import { SystemService } from '@/services/system-service';

    import Layout from '@/layouts/Default';

    import SystemHeader from '@/components/System/Header';
    import SystemInfo from '@/components/System/Info';
    import SystemNavigation from '@/components/System/Navigation';    

    export default {
        name: 'System',

        components: {
            Layout,
            SystemHeader,
            SystemInfo,
            SystemNavigation
        },

        data() {
             return {           
                params: {
                    hospital: null,
                    system: null,
                    tab: null
                },   
                loading: true,
                system: null,
                hospital: null,
                hospitals: [],
                tab: null,
                tabs: [
                    {
                        name: 'configuration',
                        text: 'Configuration',
                        component: () => import('@/components/System/Configuration')
                    },                    
                    {
                        name: 'training',
                        text: 'Training',
                        component: () => import('@/components/System/Training')
                    },                    
                    {
                        name: 'work-order',
                        text: 'Work orders',
                        component: () => import('@/components/System/WorkOrder')
                    },
                    {
                        name: 'tickets',
                        text: 'Tickets',
                        component: () => import('@/components/System/Tickets')
                    },                    
                    {
                        name: 'service-contract',
                        text: 'Service contract',
                        component: () => import('@/components/System/ServiceContract')
                    },
                ],
                path:[]
            }
        },

        watch: {
			'$route' (to) {
                this.initRouteParams(to);
				this.update();
            }
        },
        
        created() {
            this.initRouteParams(this.$route);
            this.hospitalService = new HospitalService(this.$api, this.$store);
            this.systemService = new SystemService(this.$api, this.$store);  
        },

        async mounted() {
            this.hospitals = await this.hospitalService.list();
            this.system = await this.systemService.getSystem(this.$route.params.system);


            this.loading = false;

            this.update();
        },

        methods: {
            initRouteParams(route) {
                this.params.hospital = +route.params.hospital;                
                this.params.system = +route.params.system;
                this.params.tab = route.params.tab;
            },

            update() { 
                var self = this;
                var temp = this.hospitals.filter(function(h) {
                    return h.id == self.$route.params.hospital;
                });
                this.hospital = temp[0];

                this.tab = this.params.tab ? this.tabs.findByName(this.params.tab): this.tabs[0];

                this.path = [];

                this.path.push(
                    {name:this.hospital.locationName, last:false, path:'/hospitals/' + this.params.hospital},
                    {name:'Systems', last:false, path:'/hospitals/' + this.params.hospital + '/systems'},
                    {name:this.system.productConfigurationDescription, last:true, path:'/hospitals/' + this.params.hospital + '/systems/' + this.$route.params.system}
                );  
            }
        }
    }
</script>
